<template>
  <div class="main">
    <div class="header">
      <!--      头部-->
      <Header
        @toLocation="toLocation"
        :headerMenuSelectedKey="headerMenuSelectedKey"/>
    </div>
    <!--    banner图-->
    <div class="banner">
      <div class="item">
        <img :src="dataList[currentIndex]">
      </div>
      <div class="page" v-if="this.dataList.length > 1">
        <ul>
          <ul>
            <li @click="gotoPrev" class="pre">&lt;</li>
            <li @click="gotoNext" class="next">&gt;</li>
          </ul>
        </ul>
      </div>
    </div>
    <!--    企业微信-->
    <div class="enterpriseWechat">
      <EnterpriseWechat/>
    </div>
    <!--    内容-->
    <div class="content">
      <!--      我们的解决方案-->
      <div class="solution-box">
        <h1>我们的解决方案</h1>
        <div class="line">
          <div class="line-left"></div>
          <div class="line-right"></div>
        </div>
        <!--        品牌设计-->
        <div class="brand-design">
          <h2>品牌设计</h2>
          <p>品牌差异化是医疗健康品牌竞争的核心，在现在的同质化市场上，每一个品牌都应有自己的定位与标签<br>
            “模仿”看似事半功倍，但市场代价往往高于“做自己”</p>
          <div class="representative-box">
            <div class="representative">
              <div class="img_div" @click="checkDetails">
                <img src="static/image/solution/ppsj-hssw.jpg" class="img-div-img">
                <a href="#">
                  <div class="mask">
                    <h3>海森生物LOGO</h3>
                    <p>品牌LOGO设计</p>
                  </div>
                </a>
              </div>
              <div class="img_div" @click="checkDetails">
                <img src="static/image/solution/ppsj-klyy.jpg" class="img-div-img">
                <a href="#">
                  <div class="mask">
                    <h3>康瓴医药LOGO</h3>
                    <p>品牌LOGO设计</p>
                  </div>
                </a>
              </div>
              <div class="img_div" @click="checkDetails">
                <img src="static/image/solution/ppsj-ndtw.jpg" class="img-div-img">
                <a href="#">
                  <div class="mask">
                    <h3>耐地他韦</h3>
                    <p>产品LOGO设计</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      医疗数字化-->
      <div class="brand-design">
        <h2>医疗数字化</h2>
        <p>医疗数字化营销与赋能，可增强消费者对医疗健康品牌的信赖度<br>
          强化公域营销的同时，营造私域流量圈层，提升品牌粘性</p>
        <div class="representative-box">
          <div class="number">
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/GE-PC.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>GE京东</h3>
                  <p>GE京东网站设计与开发—PC端</p>
                </div>
              </a>
            </div>
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/GE-phone.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>GE京东</h3>
                  <p>GE京东网站设计与开发—手机端</p>
                </div>
              </a>
            </div>
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/GE-applet.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>GE</h3>
                  <p>GE官方小程序页面设计</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--      平台视觉包装-->
      <div class="brand-design">
        <h2>平台视觉包装</h2>
        <p>平台作为品牌的私域阵地，可以更加有效的传递品牌价值，并打造消费者粘性<br>
          符合品牌形象的视觉化平台包装成为不可或缺的部分</p>
        <div class="representative-box">
          <div class="number">
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/baihui.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>柏荟医疗</h3>
                  <p>柏荟医疗官方网站设计与开发</p>
                </div>
              </a>
            </div>
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/haisen.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>海森生物</h3>
                  <p>海森生物官方网站设计与开发</p>
                </div>
              </a>
            </div>
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/GE-PC.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>GE京东</h3>
                  <p>GE京东网站设计与开发</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--      公众号运营-->
      <div class="brand-design">
        <h2>公众号运营</h2>
        <p>消费者对于品牌的信赖与认可，需要品牌方持之以恒的引导<br>
          周期性的品牌传播，需要在科学和合理的方案下进行</p>
        <div class="representative-box">
          <div class="number">
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/haisen-2.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>海森生物</h3>
                  <p>海森生物官方微信设计与维护</p>
                </div>
              </a>
            </div>
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/longmo.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>龙膜</h3>
                  <p>龙膜官方微信活动页面设计</p>
                </div>
              </a>
            </div>
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/laiyin.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>品牌设计</h3>
                  <p>海森官方网站设计与开发</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--      热点海报-->
      <div class="brand-design">
        <h2>热点海报</h2>
        <p>消费者容易涌向热点，这是源于人类的本能心理反应<br>
          有效的借助热点进行“借势营销”则可为医疗健康品牌带来额外的正向作用</p>
        <div class="representative-box">
          <div class="number">
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/dabao.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>大宝</h3>
                  <p>大宝男士活动热点海报设计</p>
                </div>
              </a>
            </div>
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/lvgu.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>绿谷制药</h3>
                  <p>绿谷制药节气热点海报</p>
                </div>
              </a>
            </div>
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/rdhb-qls.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>乔洛施</h3>
                  <p>乔洛施品牌海报</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--      视频创意-->
      <div class="brand-design">
        <h2>视频创意</h2>
        <p>动态的画面往往比静态的图片更加生动，使您的医学传播更加清晰有力<br>
          专业的视频团队可以精准高效的表达出您要传递的医疗健康观点</p>
        <div class="representative-box">
          <div class="representative">
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/spcy-lnkt.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>雷诺考特</h3>
                  <p>雷诺考特产品原理视频</p>
                </div>
              </a>
            </div>
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/spcy-shxyd.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>上海信易贷</h3>
                  <p>上海信易贷宣传视频</p>
                </div>
              </a>
            </div>
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/nosmoke.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>品牌设计</h3>
                  <p>海森官方网站设计与开发</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--      演示设计-->
      <div class="brand-design">
        <h2>演示设计</h2>
        <p>基于信息传播的递减法则，如何有效的传播重要信息就显得至关重要<br>
          演示设计通过艺术手法，有效的提升了信息传递的专业性和准确性</p>
        <div class="representative-box">
          <div class="representative">
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/yssj-pa.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>平安好医</h3>
                  <p>平安好医宣传演示设计</p>
                </div>
              </a>
            </div>
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/yssj-bctm.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>奔驰</h3>
                  <p>奔驰贴膜宣传演示设计</p>
                </div>
              </a>
            </div>
            <div class="img_div" @click="checkDetails">
              <img src="static/image/solution/yssj-lm.jpg" class="img-div-img">
              <a href="#">
                <div class="mask">
                  <h3>龙膜</h3>
                  <p>龙膜蓝光膜宣传演示设计</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--      数字平台搭建-->

    </div>
    <!--    尾部-->
    <div class="footer">
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import EnterpriseWechat from "../components/EnterpriseWechat";

export default {
  components: {Header, Footer, EnterpriseWechat},
  data() {
    return {
      headerMenuSelectedKey: 'solution',//todo
      subMenuSelectedKey: '',//todo
      dataList: ["static/image/solution/banner1.jpg", "static/image/solution/banner2.jpg",],
      currentIndex: 0,   //默认显示图片
    };
  },
  watch: {},
  created() {

  },
  mounted() {
    document.title = "解决方案";
    this.gotoPage()
  },
  methods: {
    toLocation(location) {
      this.subMenuSelectedKey = location
      if (location == 'brandDesign') {
        document.documentElement.scrollTop = 670
      } else if (location == 'medicalDigitalization') {
        document.documentElement.scrollTop = 1370
      } else if (location == 'platformVisual') {
        document.documentElement.scrollTop = 2070
      } else if (location == 'officialAccount') {
        document.documentElement.scrollTop = 2770
      } else if (location == 'hotPosters') {
        document.documentElement.scrollTop = 3470
      } else if (location == 'videoCreativity') {
        document.documentElement.scrollTop = 4170
      } else if (location == 'demoDesign') {
        document.documentElement.scrollTop = 4870
      }
    },
    checkDetails(e) {
      this.$router.push({path: '/CaseDisplay'})
    },
    gotoPrev() {
      this.currentIndex--
    },
    gotoNext() {
      this.currentIndex++;
      if (this.currentIndex == this.dataList.length) {
        this.currentIndex = 0;
      }
    },
    gotoPage() {
      setInterval(() => {
        this.gotoNext()
      }, 3000)
    },
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(249, 249, 249, 1);
}

.header {
  width: 1920px;
  height: 60px;
}

.enterpriseWechat {
  position: fixed;
  top: 45%;
  right: 0;
}

.banner {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

.banner img {
  width: 100%;
  display: block;
}

.banner .page {
  /*background: rgba(0, 0, 0, .5);*/
  color: #ffffff;
  letter-spacing: 20px;
  position: absolute;
  right: 0;
  bottom: 50%;
  width: 100%;
}

.banner .page ul {
  display: flex;
  justify-content: center;
  align-content: center;
}

.pre {
  position: absolute;
  left: 10px;
  font-size: 30px;
}

.next {
  position: absolute;
  right: 0px;
  font-size: 30px;
}

.content {
  width: 1400px;
  height: auto;
}

.solution-box {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 50px;
}

h1 {
  color: #D1121C;
  font-size: 34px;
  text-align: center;
}

.line {
  margin-top: 20px;
}

.line-left {
  width: 37px;
  height: 8px;
  background: #D1121C;
  border-radius: 10px;
  float: left;
}

.line-right {
  width: 119px;
  height: 8px;
  background: #D1121C;
  border-radius: 10px;
  float: left;
  margin-left: 10px;
}

.brand-design {
  width: 100%;
  height: auto;
  margin-bottom: 100px;
}

.brand-design h2 {
  font-size: 22px;
  color: #D1121C;
  font-weight: bold;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 20px;
}

.brand-design p {
  font-size: 14px;
  text-align: center;
  font-weight: bold;
}

.representative-box {
  height: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.representative {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 50px;
}

.number {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 50px;
}

.img_div {
  position: relative;
  width: 450px;
  height: 450px;
}

.img-div-img {
  width: 450px;
  height: 450px;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 450px;
  height: 450px;
  background: rgba(209, 18, 28, 0.8);
  color: #ffffff;
  opacity: 0;
}

.mask h3 {
  font-size: 26px;
  color: #FFFFFF;
  margin-top: 350px;
  margin-left: 20px;
}

.mask p {
  color: #FFFFFF;
  text-align: left;
  margin-left: 20px;
}

.img_div a:hover .mask {
  transition: 200ms;
  opacity: 1;
}

.footer {
  height: 189px;
  width: 1920px;
  overflow: hidden;
  position: relative;
  bottom: 0;
}

</style>



// WEBPACK FOOTER //
// src/views/Solution.vue